export const DeclarationsToolBarName = 'declarationsToolBarComponent';
